import { render } from "./JobItem.vue?vue&type=template&id=0f953512&scoped=true"
import script from "./JobItem.vue?vue&type=script&lang=js"
export * from "./JobItem.vue?vue&type=script&lang=js"

import "./JobItem.vue?vue&type=style&index=0&id=0f953512&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f953512"]])

export default __exports__